import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { GenesysIframeModule } from 'shared/components/genesys-iframe/genesys-iframe.module';
import { GenesysCobrowseBoxComponent } from './genesys-cobrowse-box.component';

@NgModule({
  imports: [SvgIconModule, TranslateModule, GenesysIframeModule, CommonModule],
  declarations: [GenesysCobrowseBoxComponent],
  exports: [GenesysCobrowseBoxComponent]
})
export class GenesysCobrowseBoxModule {}
